export const FLAG_ORY_SESSION = 'frontend_ory_session_support'
export const FLAG_DOUBTFUL_DEBT_REPORT = 'frontend_doubtful_debt_report'
export const FLAG_HIDE_ZEZAM_ADMIN = 'admin_app_hide_zezam_admin'
export const FLAG_MARKETING_NOTIFICATIONS = 'admin_app_marketing_notifications'
